import { render, staticRenderFns } from "./PanelOperatorHeader.vue?vue&type=template&id=33b37ef5&scoped=true&"
import script from "./PanelOperatorHeader.vue?vue&type=script&lang=js&"
export * from "./PanelOperatorHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelOperatorHeader.vue?vue&type=style&index=0&id=33b37ef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b37ef5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b37ef5')) {
      api.createRecord('33b37ef5', component.options)
    } else {
      api.reload('33b37ef5', component.options)
    }
    module.hot.accept("./PanelOperatorHeader.vue?vue&type=template&id=33b37ef5&scoped=true&", function () {
      api.rerender('33b37ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelOperatorHeader.vue"
export default component.exports